import { useState, useEffect, useContext } from "react";
import axios from "../../api/axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import "../../styles/signStyle.css";

const Signin = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const {
    setUserRole,
    setUserId,
    setUserName,
    setUserEmail,
  } = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setPageLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setError("");

  try {
    const { email, password } = formData;

    const res = await axios.post(
      "/auth/signin",
      { email, password },
      { withCredentials: true }
    );

    const data = res.data;

    const role = data.role || data.user?.role;
    const id = data._id || data.user?._id;
    const name = data.name || data.user?.name;
    const userEmail = data.email || data.user?.email;

    if (!role) {
      setError(data?.message || "Login failed");
      setIsLoading(false);
      return;
    }

    // store auth
    localStorage.setItem("userId", id);
    localStorage.setItem("userName", name);
    localStorage.setItem("userEmail", userEmail);
    localStorage.setItem("userRole", role);

    // context
    setUserRole(role);
    setUserId(id);
    setUserName(name);
    setUserEmail(userEmail);

    // redirect (NO timeout)
    if (role === "founder") {
      navigate("/main/dashboard");
    } else if (role === "support") {
      navigate("/agent/dashboard");
    }

  } catch (err) {
    console.error("Signin failed:", err);

    setError(
      err.response?.data?.message || "Server error. Please try again."
    );
  } finally {
    setIsLoading(false);
  }
};

  // =========================
  // LOADER SCREEN
  // =========================
  if (pageLoading) {
    return (
      <div className="page-loader">
        <div className="loader-char-container">
          <div className="loader-char">
            <span className="char1">ሀ</span>
            <span className="outline-spin"></span>
          </div>

          <div className="loader-char">
            <span className="char2">ሁ</span>
            <span className="outline-spin"></span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="signin-page">
      <div className="signin-card">

        <h1 className="signin-title">
          Sign in to HaHu Bingo!
        </h1>

        <div className="signin-divider">
          <span className="login">Login</span>
        </div>

        {error && (
          <div className="signin-error">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#b31010"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="signin-form">

          {/* EMAIL */}
          <div className={`inputt-group ${formData.email ? "filled" : ""}`}>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              autoComplete="email"
              disabled={isLoading}
            />
            <label>Email</label>
          </div>

          {/* PASSWORD */}
          <div className={`inputt-group ${formData.password ? "filled" : ""}`}>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              autoComplete="current-password"
              disabled={isLoading}
            />

            <label>Password</label>

            <span
              className="toggle-password"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? "🙈" : "👁️"}
            </span>
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            className="signin-button"
            disabled={isLoading}
          >
            {isLoading ? "Signing in..." : "Login"}
          </button>

        </form>
      </div>
    </div>
  );
};

export default Signin;